import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Loading from "../../components/preloader/Loading";
import {
  Input,
  Button,
  Label,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  Progress,
  Alert
} from "reactstrap";

const LoginPopup = ({ showPopup, failedRequestInfo, closePopup }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const apiBaseUrl = window.clipship_config.ApiBaseUrl;

  const resolveRequests = (newToken) => {
    window.localStorage.setItem("token", newToken);

    if (Array.isArray(failedRequestInfo) && failedRequestInfo.length > 0) {
      failedRequestInfo.forEach((requestObj) => {
        requestObj.request.headers["Authorization"] = `Bearer ${newToken}`;
        axios.request(requestObj.request).then(requestObj.resolve, requestObj.reject);
      });
      closePopup();
    }
  };

  const submit = (e) => {
    e.preventDefault();

    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const loginPayload = { email, password };

    if (!email || !password) {
      setMessage("Please fill in the fields");
    } else {
      setIsLoading(true);
      axios
        .post(`${apiBaseUrl}/login`, loginPayload)
        .then((resp) => {
          setIsLoading(false);
          if (resp?.data?.token) {
            closePopup();
            resolveRequests(resp.data.token);
          } else {
            const errorMessage = resp?.data?.error ||
              "There was an issue logging in. Please try again.";
            setMessage(errorMessage);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          const errorMessage = error?.response?.data?.error ||
            "There was an issue logging in. Please try again.";
          setMessage(errorMessage);
        });
    }
  };

  return (
    <Modal className="login-popup" isOpen={showPopup}>
      <ModalBody>
      <img style={{height:80, marginLeft: 'auto', marginRight: 'auto', display: 'block'}} src="https://provopw.org/clipandship/provo_logo_color.png" />
        <h3 className="text-center mb-4" style={{marginTop:25, color: '#149cd8'}}>Digital Data Request Login</h3>
        <Form className="login-form" onSubmit={submit}>
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              id="email"
              name="email"
              disabled={isLoading}
              type="email"
              innerRef={emailRef}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">Password</Label>
            <Input
              id="password"
              name="password"
              disabled={isLoading}
              type="password"
              innerRef={passwordRef}
              required
            />
          </FormGroup>
          {!!message && <Alert color="danger">{message}</Alert>}
          {isLoading && <Progress animated value="100" />}
          {!isLoading && <Button className="rounded-pill" type="submit" color="primary" block>
            Login
          </Button>}
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default LoginPopup;
